import { Checkbox, FormControlLabel } from "@mui/material";
import { get } from "lodash";
import React, { useEffect } from "react";
import DealComplianceModal from "../../../common/js/components/DealComplianceModal";
import Installments from "../deal/Installments";
import BrokerCommissions from "./BrokerCommissions";
import CommissionDistribution from "./CommissionDistribution";
import { disabledStatuses } from "./constants";
import "./VoucherForm.css";

const VoucherForm = (props) => {
    const {
        autocompleteResults,
        brokerCommissions,
        clearStatusTracker,
        deal,
        documentWarning,
        errors,
        getStatusTrackerData,
        handleAddArrayElement, //(path)
        handleAddBrokerCommission,
        handleAddRunner,
        handleCheckboxClick,
        handleConfirmWarning,
        handleCreateOutsideSplitDraft,
        handleDeleteOutsideSplit,
        handleDocumentWarning,
        handleInput,
        handleReducerLevelInput,
        handleRemoveCommissionOrRunner,
        handleSaveOutsideSplit,
        handleSearchBroker,
        handleSearchCompany,
        handleSearchPerson,
        handleUpdateArrayElement, //(arrayPath, index, field, value)
        handleVoucherChangeAndCalculateSplits,
        outsideSplitModal,
        outsideSplits,
        searchResults,
        toggleOutsideSplitModal,
        updateBrokerPerson,
        updateRunner,
        updateSplit,
        userProfile,
        voucher,
    } = props;

    useEffect(() => {
        const abortController = new AbortController();
        getStatusTrackerData(voucher?.voucherKey, "VOUCHER", abortController.signal);
        return () => {
            abortController.abort();
            clearStatusTracker();
        };
    }, []);

    const formDisabled = get(disabledStatuses, `${userProfile.role}.${voucher.voucherStatus}`, true);

    return (
        <React.Fragment>
            <form>
                <div className="simPaper">
                    <div className={"formTitleNoSpace"}> Voucher Information </div>
                    <small className="entityIDText">Deal ID: {voucher.deal.dealKey}</small>
                    <CommissionDistribution {...props} formDisabled={formDisabled} />

                    <Installments
                        {...props}
                        installments={get(voucher, "deal.installments", [])}
                        handleAddArrayElement={handleAddArrayElement}
                        handleUpdateArrayElement={(arrayPath, index, field, value) =>
                            handleUpdateArrayElement("deal." + arrayPath, index, field, value)
                        }
                        errors={errors}
                        disableInputs={formDisabled}
                        onlyEditCurrentAndFuture={true}
                        preventAddSubtract={true}
                        voucher={voucher}
                        handleVoucherChangeAndCalculateSplits={handleVoucherChangeAndCalculateSplits}
                        isVoucher={true}
                    />

                    <div className="voucherFormDisplayFlexUnresponsive">
                        <div className="kmExclusive">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={get(voucher, "deal.kmExclusiveFlg") ? true : false}
                                        onChange={(e) => handleCheckboxClick("deal.kmExclusiveFlg", e)}
                                        value={voucher.kmExclusiveFlg}
                                        color="primary"
                                        disabled={formDisabled}
                                    />
                                }
                                label="Is this listing KM Exclusive?"
                            />
                        </div>
                        <div>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={get(voucher, "deal.propertyManagementPaymentFlg") ? true : false}
                                        onChange={(e) => handleCheckboxClick("deal.propertyManagementPaymentFlg", e)}
                                        value={voucher.propertyManagementPaymentFlg}
                                        color="primary"
                                        disabled={formDisabled}
                                    />
                                }
                                label="Is this payment handled by Asset Services?"
                            />
                        </div>
                    </div>

                    <hr />

                    <BrokerCommissions
                        {...props}
                        voucher={voucher}
                        brokerCommissions={brokerCommissions}
                        outsideSplits={outsideSplits}
                        handleAddBrokerCommission={handleAddBrokerCommission}
                        handleCreateOutsideSplitDraft={handleCreateOutsideSplitDraft}
                        handleSaveOutsideSplit={handleSaveOutsideSplit}
                        handleDeleteOutsideSplit={handleDeleteOutsideSplit}
                        handleAddRunner={handleAddRunner}
                        handleRemoveCommissionOrRunner={handleRemoveCommissionOrRunner}
                        updateSplit={updateSplit}
                        updateRunner={updateRunner}
                        outsideSplitModal={outsideSplitModal}
                        toggleOutsideSplitModal={toggleOutsideSplitModal}
                        handleSearchPerson={handleSearchPerson}
                        handleSearchCompany={handleSearchCompany}
                        searchResults={searchResults}
                        updateBrokerPerson={updateBrokerPerson}
                        errors={errors}
                        formDisabled={formDisabled}
                        autocompleteResults={autocompleteResults}
                        handleSearchBroker={handleSearchBroker}
                        handleInput={(path, value) => handleInput(path, value)}
                        handleReducerLevelInput={handleReducerLevelInput}
                    />
                </div>
            </form>
            <DealComplianceModal
                documentWarning={documentWarning}
                documentTypeKey={(deal?.transactionType ?? "").toLowerCase()}
                handleDocumentWarning={handleDocumentWarning}
                handleConfirmWarning={handleConfirmWarning}
                dealKey={deal.dealKey}
            />
        </React.Fragment>
    );
};

export default VoucherForm;
